export default "/images/c4ced22fdf264413d7d0aef050674b7a.avif";